import age from '@/filters/age'
import capitalize from '@/filters/capitalize'
import cleanHtmlTags from '@/filters/cleanHtmlTags'
import date from '@/filters/date'
import datetime from '@/filters/datetime'
import first from '@/filters/first'
import globalNumber from '@/filters/globalNumber'
import humanReadable from '@/filters/humanReadable'
import isEmpty from '@/filters/isEmpty'
import isNotExpired from '@/filters/isNotExpired'
import number from '@/filters/number'
import percent from '@/filters/percent'
import phone from '@/filters/phone'
import phoneFormat from '@/filters/phoneFormat'
import substring from '@/filters/substring'
import truncate from '@/filters/truncate'

export const filters = {
  age,
  capitalize,
  date,
  cleanHtmlTags,
  datetime,
  first,
  globalNumber,
  humanReadable,
  isEmpty,
  isNotExpired,
  number,
  percent,
  phone,
  phoneFormat,
  substring,
  truncate
}
